@let configs = getConfigs();

<app-base-modal class="modal">
  <div class="modal__content-wrapper">
    <div class="modal__content">
      <app-icon [icon]="configs.iconName" class="modal__icon" />

      <div class="modal__text-block">
        <h3 class="modal__title">
          {{ configs.titleKey | translate }}
        </h3>

        <p class="modal__description">
          {{ configs.descriptionKey | translate }}
        </p>
      </div>
    </div>

    <div class="modal__content-control">
      <button class="secondary-button modal__close" (click)="close()">
        {{ 'user-profile.activeSessions.response.close' | translate }}
      </button>
    </div>
  </div>
</app-base-modal>
